import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuService } from './app.menu.service';
import { ConfirmationService, MenuItem, PrimeNGConfig } from 'primeng/api';
import { AppComponent } from './app.component';
import { BreadcrumbService } from './app.breadcrumb.service';
import { AbstractService } from './services/abstract.service';

export interface AbaNavegacao {
    chave: string;
    url: string;
    titulo: string;
    icone: string;
}

const ABA_INICIAL = '/home';
const ICONE_PADRAO = 'pi pi-fw pi-file';
const MAXIMO_ABAS = 12;

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    providers: [ConfirmationService]
})
export class AppMainComponent implements OnInit, OnDestroy {

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    menuHoverActive: boolean;

    rightPanelActive: boolean;

    rightPanelClick: boolean;

    configActive: boolean;

    configClick: boolean;

    @ViewChild('appMenu') appMenu: any;

    abas: AbaNavegacao[] = [];

    abaAtiva: string;

    abaInicial = ABA_INICIAL;

    menuLateralRecolhido = localStorage.getItem('menu-lateral-recolhido') === '1';

    menuLateralHover = false;

    grupoMenuAberto: any = null;

    private timerMenuLateral: ReturnType<typeof setTimeout>;

    private tituloDaNavegacao: string;

    private inscricoes: Subscription[] = [];

    constructor(
        private menuService: MenuService,
        private primengConfig: PrimeNGConfig,
        public app: AppComponent,
        private router: Router,
        private breadcrumbService: BreadcrumbService
    ) {
        this.abas = this.lerAbas();
        this.garantirAbaInicial();
        this.inscricoes.push(
            this.breadcrumbService.itemsHandler.subscribe((itens) => this.aoMudarBreadcrumb(itens)),
            this.router.events.subscribe((evento) => {
                if (evento instanceof NavigationStart) {
                    this.tituloDaNavegacao = undefined;
                } else if (evento instanceof NavigationEnd) {
                    this.aoNavegar(evento.urlAfterRedirects);
                }
            })
        );
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
    }

    ngOnDestroy() {
        this.inscricoes.forEach((inscricao) => inscricao.unsubscribe());
        clearTimeout(this.timerMenuLateral);
    }

    get menuLateralNovo(): boolean {
        return this.isDesktop();
    }

    get menuLateralCompacto(): boolean {
        return this.menuLateralNovo && this.menuLateralRecolhido && !this.menuLateralHover && !this.grupoMenuAberto;
    }

    abrirGrupoMenu(item) {
        this.grupoMenuAberto = this.grupoMenuAberto === item ? null : item;
        if (this.menuLateralRecolhido) {
            this.menuLateralHover = true;
        }
    }

    alternarMenuLateral() {
        this.menuLateralRecolhido = !this.menuLateralRecolhido;
        this.recolherMenuLateral();
        try {
            localStorage.setItem('menu-lateral-recolhido', this.menuLateralRecolhido ? '1' : '0');
        } catch (e) {}
    }

    recolherMenuLateral() {
        this.menuLateralHover = false;
        this.grupoMenuAberto = null;
    }

    entrarMenuLateral() {
        clearTimeout(this.timerMenuLateral);
        if (this.menuLateralNovo && this.menuLateralRecolhido) {
            this.menuLateralHover = true;
        }
    }

    sairMenuLateral() {
        if (!this.menuLateralHover) {
            return;
        }
        this.timerMenuLateral = setTimeout(() => this.recolherMenuLateral(), 300);
    }

    chaveDaAba(_: number, aba: AbaNavegacao) {
        return aba.chave;
    }

    abrirAba(aba: AbaNavegacao) {
        if (aba.chave !== this.abaAtiva) {
            this.router.navigateByUrl(aba.url);
        }
    }

    fecharAba(aba: AbaNavegacao, evento: Event) {
        evento.stopPropagation();
        if (aba.chave === ABA_INICIAL) {
            return;
        }
        if (aba.chave !== this.abaAtiva) {
            this.removerAba(aba);
            return;
        }
        const indice = this.abas.indexOf(aba);
        const proxima = this.abas[indice + 1] || this.abas[indice - 1];
        this.router.navigateByUrl(proxima.url).then((navegou) => {
            if (navegou) {
                this.removerAba(aba);
            }
        });
    }

    private removerAba(aba: AbaNavegacao) {
        this.abas = this.abas.filter((a) => a !== aba);
        this.salvarAbas();
    }

    private aoNavegar(url: string) {
        const chave = this.chaveDaUrl(url);
        if (!chave || chave === '/') {
            return;
        }
        this.abaAtiva = chave;
        const item = this.itemDoMenu(chave);
        let aba = this.abas.find((a) => a.chave === chave);
        if (!aba) {
            aba = { chave, url, titulo: '', icone: '' };
            this.abas = [...this.abas, aba];
            this.limitarAbas();
        }
        aba.url = url;
        if (chave !== ABA_INICIAL) {
            aba.titulo = this.tituloDaNavegacao || aba.titulo || item?.label || 'Tela';
        }
        aba.icone = aba.icone && aba.icone !== ICONE_PADRAO ? aba.icone : item?.icon || ICONE_PADRAO;
        this.salvarAbas();
        if (!item) {
            setTimeout(() => this.completarAbas());
        }
    }

    private aoMudarBreadcrumb(itens: MenuItem[]) {
        const rotulos = (itens || []).filter((i) => i && i.label);
        if (!rotulos.length) {
            return;
        }
        const ultimo = rotulos[rotulos.length - 1];
        const anterior = rotulos[rotulos.length - 2];
        const titulo = anterior && anterior.routerLink ? anterior.label + ': ' + ultimo.label : ultimo.label;
        this.tituloDaNavegacao = titulo;
        Promise.resolve().then(() => {
            const aba = this.abas.find((a) => a.chave === this.abaAtiva);
            if (aba && aba.chave !== ABA_INICIAL && aba.titulo !== titulo) {
                aba.titulo = titulo;
                this.salvarAbas();
            }
        });
    }

    private completarAbas() {
        this.abas.forEach((aba) => {
            const item = this.itemDoMenu(aba.chave);
            if (item && aba.icone === ICONE_PADRAO && item.icon) {
                aba.icone = item.icon;
            }
            if (item && aba.titulo === 'Tela') {
                aba.titulo = item.label;
            }
        });
        this.salvarAbas();
    }

    private itemDoMenu(chave: string): { label: string; icon: string } {
        let melhor: { label: string; icon: string; tamanho: number };
        const visitar = (itens: any[], iconePai?: string) => {
            (itens || []).forEach((item) => {
                const icone = item.icon || iconePai;
                const link = Array.isArray(item.routerLink) ? item.routerLink[0] : item.routerLink;
                if (typeof link === 'string' && link.length > 1) {
                    const caminho = link.startsWith('/') ? link : '/' + link;
                    const casa = chave === caminho || chave.startsWith(caminho + '/');
                    if (casa && (!melhor || caminho.length > melhor.tamanho)) {
                        melhor = { label: item.label, icon: icone, tamanho: caminho.length };
                    }
                }
                visitar(item.items, icone);
            });
        };
        visitar(this.appMenu?.model);
        return melhor;
    }

    private chaveDaUrl(url: string) {
        return (url || '').split('#')[0].split('?')[0];
    }

    private garantirAbaInicial() {
        if (!this.abas.some((a) => a.chave === ABA_INICIAL)) {
            this.abas = [{ chave: ABA_INICIAL, url: ABA_INICIAL, titulo: 'Início', icone: 'pi pi-fw pi-home' }, ...this.abas];
        }
    }

    private limitarAbas() {
        while (this.abas.length > MAXIMO_ABAS) {
            const antiga = this.abas.find((a) => a.chave !== ABA_INICIAL && a.chave !== this.abaAtiva);
            if (!antiga) {
                return;
            }
            this.abas = this.abas.filter((a) => a !== antiga);
        }
    }

    private chaveDoArmazenamento() {
        const usuario = AbstractService.getLocalStorage('usuario');
        return 'central-abas:' + (usuario?.login || '');
    }

    private lerAbas(): AbaNavegacao[] {
        try {
            const salvas = JSON.parse(sessionStorage.getItem(this.chaveDoArmazenamento()) || '[]');
            if (!Array.isArray(salvas)) {
                return [];
            }
            return salvas
                .filter((a) => a && typeof a.chave === 'string' && typeof a.url === 'string' && a.url.startsWith('/') && !a.url.startsWith('//'))
                .map((a) => ({
                    chave: a.chave,
                    url: a.url,
                    titulo: String(a.titulo || ''),
                    icone: String(a.icone || ''),
                }));
        } catch (e) {
            return [];
        }
    }

    private salvarAbas() {
        try {
            sessionStorage.setItem(this.chaveDoArmazenamento(), JSON.stringify(this.abas));
        } catch (e) {}
    }

    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.rightPanelClick) {
            this.rightPanelActive = false;
        }

        if (!this.menuClick) {
            if (this.isHorizontal() || this.isSlim()) {
                this.menuService.reset();
            }

            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }

            this.grupoMenuAberto = null;

            this.menuHoverActive = false;
        }

        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }

        this.configClick = false;
        this.topbarItemClick = false;
        this.menuClick = false;
        this.rightPanelClick = false;
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.topbarMenuActive = false;

        if (this.isSlim()) {
            this.app.menuMode ='static';
        } else {
            this.app.menuMode = 'slim';
        }

        // if (this.isOverlay()) {
        //     this.overlayMenuActive = !this.overlayMenuActive;
        // }
        // if (this.isDesktop()) {
        //     this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        // } else {
        //     this.staticMenuMobileActive = !this.staticMenuMobileActive;
        // }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onRightPanelButtonClick(event) {
        this.rightPanelClick = true;
        this.rightPanelActive = !this.rightPanelActive;
        event.preventDefault();
    }

    onRippleChange(event) {
        this.app.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    onRightPanelClick() {
        this.rightPanelClick = true;
    }

    isHorizontal() {
        return this.app.menuMode === 'horizontal';
    }

    isSlim() {
        return this.app.menuMode === 'slim';
    }

    isOverlay() {
        return this.app.menuMode === 'overlay';
    }

    isStatic() {
        return this.app.menuMode === 'static';
    }

    isMobile() {
        return window.innerWidth < 1025;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    hideOverlayMenu() {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }
}
